type TNoopReducer<T> = (state?: T) => T;

export function noopReducer<State>(defaults?: null): TNoopReducer<State | null>;
export function noopReducer<State>(defaults: State): TNoopReducer<State>;
export function noopReducer<State>(defaults: State | null | undefined = null) {
  return (state: State | null = defaults) => state;
}
